<template>
  <div class="card-wrapper">
    <b-card v-for="slider in sliders" :key="slider.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-100 mb-lg-0 mb-2 mr-2">
            {{ slider.link }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(slider.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"></i>

          <i @click="handleDelete(slider.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editSingleSliderModal" ref="editSingleSliderModal" size="lg" :title="'Edit slider'">
      <b-row v-if="!isLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('anyform.selectImageEn')">
                <b-form-file
                  v-model="editForm.image_en"
                  accept=".jpg, .jpeg, .png, .webp"
                  @change="imageUploadedEn = !imageUploadedEn"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!imageUploadedEn && imageUrlEn !== null"
                  :src="`${apiUrl}/${imageUrlEn}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group :label="$t('anyform.selectImageRu')">
                <b-form-file
                  v-model="editForm.image_ru"
                  accept=".jpg, .jpeg, .png, .webp"
                  @change="imageUploadedRu = !imageUploadedRu"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!imageUploadedRu && imageUrlRu !== null"
                  :src="`${apiUrl}/${imageUrlRu}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group :label="$t('pages.sliders.link')">
                <b-form-input type="text" v-model="$v.editForm.link.$model" :state="!$v.editForm.link.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.link.required">
                  {{ $t('formErrors.enterLink') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.faq.sort')">
                <b-form-input type="text" v-model="$v.editForm.sort.$model" :state="!$v.editForm.sort.$error" min="0" />
                <b-form-invalid-feedback v-if="!$v.editForm.sort.required">
                  {{ $t('formErrors.enterSort') }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback v-else-if="!$v.editForm.sort.numeric">
                  {{ $t('formErrors.mustBeNumber') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
                :class="{
                  'btn-multiple-state mt-2': true,
                  'show-spinner': isLoading
                }"
              >
                <span class="spinner d-inline-block">
                  <span class="bounce1"></span>
                  <span class="bounce2"></span>
                  <span class="bounce3"></span>
                </span>
                <span class="label">
                  {{ $t('buttons.save') }}
                </span>
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editSingleSliderModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from '@/constants/config'
const { required, numeric } = require('vuelidate/lib/validators')

export default {
  props: {
    sliders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      isLoading: false,
      imageUrlEn: null,
      imageUrlRu: null,
      imageUploadedEn: false,
      imageUploadedRu: false,
      editForm: {
        link: '',
        sort: null,
        image_en: null,
        image_ru: null
      },
      currentSlider: null
    }
  },
  validations: {
    editForm: {
      link: { required },
      sort: { required, numeric }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editSingleSliderModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('sliders/deleteSingleSlider', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editSingleSliderModal')
      this.$store.dispatch('sliders/fetchSingleSlider', { id, vm: this })
      this.currentSlider = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          link: this.editForm.link,
          sort: this.editForm.sort
        }

        if (this.editForm.image_en) {
          payload.image_en = this.editForm.image_en
        }

        if (this.editForm.image_ru) {
          payload.image_ru = this.editForm.image_ru
        }

        this.$store.dispatch('sliders/updateSingleSlider', {
          payload,
          id: this.currentSlider,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.image_en = null
      this.editForm.image_ru = null
      this.editForm.link = ''
      this.editForm.sort = null
      this.imageUrlEn = null
      this.imageUrlRu = null
      this.currentSlider = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
